"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var check_svg_1 = __importDefault(require("../../../assets/icons/acoes/check.svg"));
var add_svg_1 = __importDefault(require("../../../assets/icons/acoes/add.svg"));
var alt_route_svg_1 = __importDefault(require("../../../assets/icons/acoes/alt_route.svg"));
var archive_svg_1 = __importDefault(require("../../../assets/icons/acoes/archive.svg"));
var attach_file_svg_1 = __importDefault(require("../../../assets/icons/acoes/attach_file.svg"));
var bookmark_svg_1 = __importDefault(require("../../../assets/icons/acoes/bookmark.svg"));
var bookmark_star_svg_1 = __importDefault(require("../../../assets/icons/acoes/bookmark_star.svg"));
var bookmark_star_fill_svg_1 = __importDefault(require("../../../assets/icons/acoes/bookmark_star-fill.svg"));
var close_svg_1 = __importDefault(require("../../../assets/icons/acoes/close.svg"));
var collapse_content_svg_1 = __importDefault(require("../../../assets/icons/acoes/collapse_content.svg"));
var content_copy_svg_1 = __importDefault(require("../../../assets/icons/acoes/content_copy.svg"));
var comment_svg_1 = __importDefault(require("../../../assets/icons/acoes/comment.svg"));
var cut_svg_1 = __importDefault(require("../../../assets/icons/acoes/cut.svg"));
var delete_svg_1 = __importDefault(require("../../../assets/icons/acoes/delete.svg"));
var download_svg_1 = __importDefault(require("../../../assets/icons/acoes/download.svg"));
var drag_indicator_svg_1 = __importDefault(require("../../../assets/icons/acoes/drag_indicator.svg"));
var download_done_svg_1 = __importDefault(require("../../../assets/icons/acoes/download_done.svg"));
var edit_svg_1 = __importDefault(require("../../../assets/icons/acoes/edit.svg"));
var expand_content_svg_1 = __importDefault(require("../../../assets/icons/acoes/expand_content.svg"));
var favorite_svg_1 = __importDefault(require("../../../assets/icons/acoes/favorite.svg"));
var favorite_fill_svg_1 = __importDefault(require("../../../assets/icons/acoes/favorite_fill.svg"));
var filter_alt_svg_1 = __importDefault(require("../../../assets/icons/acoes/filter_alt.svg"));
var filter_list_svg_1 = __importDefault(require("../../../assets/icons/acoes/filter_list.svg"));
var frame_inspect_svg_1 = __importDefault(require("../../../assets/icons/acoes/frame_inspect.svg"));
var grade_svg_1 = __importDefault(require("../../../assets/icons/acoes/grade.svg"));
var grade_fill_svg_1 = __importDefault(require("../../../assets/icons/acoes/grade_fill.svg"));
var history_svg_1 = __importDefault(require("../../../assets/icons/acoes/history.svg"));
var instant_mix_svg_1 = __importDefault(require("../../../assets/icons/acoes/instant_mix.svg"));
var local_library_svg_1 = __importDefault(require("../../../assets/icons/acoes/local_library.svg"));
var locked_svg_1 = __importDefault(require("../../../assets/icons/acoes/locked.svg"));
var power_settings_new_svg_1 = __importDefault(require("../../../assets/icons/acoes/power_settings_new.svg"));
var print_svg_1 = __importDefault(require("../../../assets/icons/acoes/print.svg"));
var published_with_changes_svg_1 = __importDefault(require("../../../assets/icons/acoes/published_with_changes.svg"));
var redo_svg_1 = __importDefault(require("../../../assets/icons/acoes/redo.svg"));
var remove_svg_1 = __importDefault(require("../../../assets/icons/acoes/remove.svg"));
var save_svg_1 = __importDefault(require("../../../assets/icons/acoes/save.svg"));
var search_svg_1 = __importDefault(require("../../../assets/icons/acoes/search.svg"));
var settings_svg_1 = __importDefault(require("../../../assets/icons/acoes/settings.svg"));
var share_svg_1 = __importDefault(require("../../../assets/icons/acoes/share.svg"));
var shuffle_svg_1 = __importDefault(require("../../../assets/icons/acoes/shuffle.svg"));
var sort_by_alpha_svg_1 = __importDefault(require("../../../assets/icons/acoes/sort_by_alpha.svg"));
var sync_svg_1 = __importDefault(require("../../../assets/icons/acoes/sync.svg"));
var text_fields_svg_1 = __importDefault(require("../../../assets/icons/acoes/text_fields.svg"));
var undo_svg_1 = __importDefault(require("../../../assets/icons/acoes/undo.svg"));
var unlocked_svg_1 = __importDefault(require("../../../assets/icons/acoes/unlocked.svg"));
var upload_svg_1 = __importDefault(require("../../../assets/icons/acoes/upload.svg"));
var visibility_svg_1 = __importDefault(require("../../../assets/icons/acoes/visibility.svg"));
var visibility_off_svg_1 = __importDefault(require("../../../assets/icons/acoes/visibility_off.svg"));
var zoom_in_svg_1 = __importDefault(require("../../../assets/icons/acoes/zoom_in.svg"));
var zoom_in_map_svg_1 = __importDefault(require("../../../assets/icons/acoes/zoom_in_map.svg"));
var zoom_out_svg_1 = __importDefault(require("../../../assets/icons/acoes/zoom_out.svg"));
var zoom_out_map_svg_1 = __importDefault(require("../../../assets/icons/acoes/zoom_out_map.svg"));
var keyboard_capslock_badge_svg_1 = __importDefault(require("../../../assets/icons/acoes/keyboard_capslock_badge.svg"));
var alternate_email_svg_1 = __importDefault(require("../../../assets/icons/acoes/alternate_email.svg"));
var whatsapp_svg_1 = __importDefault(require("../../../assets/icons/acoes/whatsapp.svg"));
var send_svg_1 = __importDefault(require("../../../assets/icons/acoes/send.svg"));
var expand_circle_down_svg_1 = __importDefault(require("../../../assets/icons/acoes/expand_circle_down.svg"));
var expand_circle_up_svg_1 = __importDefault(require("../../../assets/icons/acoes/expand_circle_up.svg"));
var Acoes = {
    "check": check_svg_1.default,
    "add": add_svg_1.default,
    "alt_route": alt_route_svg_1.default,
    "alternate_email": alternate_email_svg_1.default,
    "archive": archive_svg_1.default,
    "attach_file": attach_file_svg_1.default,
    "bookmark": bookmark_svg_1.default,
    "bookmark_star": bookmark_star_svg_1.default,
    "bookmark_star_fill": bookmark_star_fill_svg_1.default,
    "close": close_svg_1.default,
    "collapse_content": collapse_content_svg_1.default,
    "content_copy": content_copy_svg_1.default,
    "comment": comment_svg_1.default,
    "cut": cut_svg_1.default,
    "delete": delete_svg_1.default,
    "download": download_svg_1.default,
    "drag_indicator": drag_indicator_svg_1.default,
    "download_done": download_done_svg_1.default,
    "edit": edit_svg_1.default,
    "expand_content": expand_content_svg_1.default,
    "favorite": favorite_svg_1.default,
    "favorite_fill": favorite_fill_svg_1.default,
    "filter_alt": filter_alt_svg_1.default,
    "filter_list": filter_list_svg_1.default,
    "frame_inspect": frame_inspect_svg_1.default,
    "grade": grade_svg_1.default,
    "grade_fill": grade_fill_svg_1.default,
    "history": history_svg_1.default,
    "instant_mix": instant_mix_svg_1.default,
    "local_library": local_library_svg_1.default,
    "locked": locked_svg_1.default,
    "power_settings_new": power_settings_new_svg_1.default,
    "print": print_svg_1.default,
    "published_with_changes": published_with_changes_svg_1.default,
    "redo": redo_svg_1.default,
    "remove": remove_svg_1.default,
    "save": save_svg_1.default,
    "search": search_svg_1.default,
    "send": send_svg_1.default,
    "settings": settings_svg_1.default,
    "share": share_svg_1.default,
    "shuffle": shuffle_svg_1.default,
    "sort_by_alpha": sort_by_alpha_svg_1.default,
    "sync": sync_svg_1.default,
    "text_fields": text_fields_svg_1.default,
    "undo": undo_svg_1.default,
    "unlocked": unlocked_svg_1.default,
    "upload": upload_svg_1.default,
    "visibility": visibility_svg_1.default,
    "visibility_off": visibility_off_svg_1.default,
    "whatsapp": whatsapp_svg_1.default,
    "zoom_in": zoom_in_svg_1.default,
    "zoom_in_map": zoom_in_map_svg_1.default,
    "zoom_out": zoom_out_svg_1.default,
    "zoom_out_map": zoom_out_map_svg_1.default,
    "keyboard_capslock_badge": keyboard_capslock_badge_svg_1.default,
    "expanded_circle_down": expand_circle_down_svg_1.default,
    "expanded_circle_up": expand_circle_up_svg_1.default,
};
exports.default = Acoes;
